import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useCompetition } from "../../base-react/hooks/Competition";
import { Loading } from "../../base-react/components/Loading";
import { AccessDenied } from "../../base-react/components/AccessDenied";
export const ManagerOutlet = () => {
    const { event_id } = useParams();
    const [, event, , loading] = useCompetition(event_id);
    if (loading || !event) {
        return React.createElement(Loading, null);
    }
    if ((event === null || event === void 0 ? void 0 : event.usercompetition_level) == null || parseInt(event.usercompetition_level) < 50) {
        return React.createElement(AccessDenied, null);
    }
    return React.createElement(Outlet, null);
};
